// extracted by mini-css-extract-plugin
module.exports = {"root":"ToCreateAcceptance_root__3Xw4_"};